var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 34,
    viewBox: "0 0 23 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.12 29.0565C19.65 31.4865 16.77 33.1565 13.31 33.5965C12.54 33.7265 11.77 33.7265 11.07 33.7265C7.23003 33.7265 3.39003 32.4465 0.570033 29.8865L2.81003 27.3865C5.43003 29.6865 9.27003 30.7165 12.86 30.2065C15.48 29.8265 17.28 28.8665 18.3 27.3265C18.81 26.3665 19 25.5965 18.68 24.6365C18.3 23.0965 16.95 21.5665 14.78 20.4765C13.56 19.8365 12.22 19.3265 10.68 18.7465C8.25003 17.8465 5.62003 16.9565 3.64003 15.2865C1.34003 13.3665 0.250031 10.8065 0.630031 8.30647C1.21003 5.42647 3.77003 2.86647 7.22003 1.71647C12.15 -0.073528 18.42 1.07647 22.32 4.85647L19.95 7.28647C16.88 4.27647 12.27 3.44647 8.30003 4.85647C5.80003 5.81647 4.27003 7.22647 4.01003 8.95647C3.75003 10.2965 4.33003 11.4565 5.74003 12.6065C7.34003 13.9465 9.45003 14.7165 11.76 15.6165C13.3 16.1265 14.9 16.7065 16.43 17.4765C19.25 18.9465 21.36 21.3165 22 23.6865C22.51 25.4765 22.13 27.5265 21.1 29.0665L21.12 29.0565Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerS);
export default __webpack_public_path__ + "static/media/LOWER_S.82c12fcd446666eb68439b36d93a927b.svg";
export { ForwardRef as ReactComponent };